module.exports = __webpack_public_path__ + "images/poster-en-e.jpg";